import defaultState from "./state";


const solicitudReajusteReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "RA_SR/MODAL_SOLICITUD_REAJUSTE_PASOS": {
      switch (action.paso) {
        case 1:
          return Object.assign({}, state, {
            modalSolicitudReajuste: true,
            modalSolicitudReajusteConfirmacion: false,
            modalSolicitudReajusteRespuesta: false,
          });
        case 2:
          return Object.assign({}, state, {
            modalSolicitudReajuste: true,
            modalSolicitudReajusteConfirmacion: true,
            modalSolicitudReajusteRespuesta: false,
          });
        case 3:
          return Object.assign({}, state, {
            modalSolicitudReajuste: true,
            modalSolicitudReajusteConfirmacion: true,
            modalSolicitudReajusteRespuesta: true,
          });
        default:
          return Object.assign({}, state, {
            modalSolicitudReajuste: false,
            modalSolicitudReajusteConfirmacion: false,
            modalSolicitudReajusteRespuesta: false,
            checkCentrosAtencion: action.isChecked ? action.data : [],
            checkTiposPrestacion: action.isChecked ? action.data : [],
            checkAranceles: action.isChecked ? action.data : [],
            checkCentrosAtencionPQ: action.isChecked ? action.data : [],
            checkVigenciasPaquetes: action.isChecked ? action.data : [],
            vigenciaReajuste: null,
            vigenciaReajustePQ: null,
            replicaArancel: null,
            replicaPaquetes: null,
            comentario: "",
            comentarioPQ: "",
            valorReajusteError: "",
            valorReajustePaquetesError: "",
          });
      }
    }

    case "RA_SR/MODAL_CONSULTAR_PERIODO_REAJUSTE": {
      return Object.assign({}, state, {
        modalColsultarPeriodoReajuste: action.accionModal,
      });
    }
    case "RA_SR/MODAL_SOLICITUD_REAJUSTE_LOADING": {
      return Object.assign({}, state, {
        modalSolicitudReajusteConfirmacionLoading: action.accionModalLoading,
      });
    }

    case "RA_SR/MODAL_SOLICITUD_REAJUSTE_CARGA_COMBINACION_VALIDA_SOLICITUD_REAJUSTE": {
      return Object.assign({}, state, {
        itemsSolicitudReajuste: action.solicitudesReajuste,
        modalSolicitudReajusteConfirmacionLoading: false,
      });
    }
    case "RA_SR/MODAL_ACEPTAR_OPEN": {
      let abrir = action.open;
      if (state.itemsSolicitudReajusteEliminados === 0) {
        abrir = false;
      }

      return Object.assign({}, state, {
        modalAceptar: abrir,
      });
    }

    case "RA_SR/MODAL_SOLICITUD_REAJUSTE_CARGA_COMBINACION_SOLICITUD_REAJUSTE": {
      const checkTipos = [];
      state.checkAranceles.map((rowArancel) => (
        state.checkCentrosAtencion.map((rowCentroAtencion) => (
          state.checkTiposPrestacion.map((rowTipoPrestacion) => (
            checkTipos.push({
              key: `${rowCentroAtencion}_${rowArancel}_${rowTipoPrestacion}`,
              tiposArancel: action.global.tiposArancel.filter((p) => p.Rut === rowArancel)[0].Descripcion,
              rutArancel: rowArancel,
              centrosAtencion: action.global.filtros_CAT.centrosAtencion.filter((p) => p.Secuencia === rowCentroAtencion)[0].Descripcion,
              secuencia: rowCentroAtencion,
              tiposPrestaciones: action.global.tiposPrestaciones.filter((p) => p.Id === rowTipoPrestacion)[0].Descripcion,
              tipoAtencion: action.global.tiposPrestaciones.filter((p) => p.Id === rowTipoPrestacion)[0].TipoAtencion,
              idTipoPrestacion: rowTipoPrestacion,
            })
          ))
        ))
      ));

      return Object.assign({}, state, {
        itemsSolicitudReajuste: checkTipos,

      });
    }

    case "RA_SR/MODAL_SOLICITUD_REAJUSTE_CARGA_COMBINACION_SOLICITUD_REAJUSTE_PAQUETES": {
      const checkTiposPQ = [];
      //state.checkAranceles.map((rowArancel) => (

      state.checkCentrosAtencionPQ.map((rowTipoArancel) => (
        state.checkVigenciasPaquetes.map((rowVigencia) => (
          checkTiposPQ.push({
            key: `${rowTipoArancel}_${rowVigencia}`,
            tiposArancel: action.global.tiposArancel.filter((p) => p.Rut === rowTipoArancel)[0].Descripcion,
            rutArancel: rowTipoArancel,
            vigencias: rowVigencia,
          })
        ))
      ))
      //));

      return Object.assign({}, state, {
        itemsSolicitudReajustePQ: checkTiposPQ,
      });
    }


    case "RA_SR/CAMBIAR_COMENTARIO": {
      return Object.assign({}, state, {
        comentario: action.comentario,
      });
    }

    case "RA_SR/CAMBIAR_COMENTARIO_PQ": {
      return Object.assign({}, state, {
        comentarioPQ: action.comentarioPQ,
      });
    }

    case "RA_SR/CAMBIAR_VALOR_REAJUSTE": {
      return Object.assign({}, state, {
        valorReajuste: action.valorReajuste,
      });
    }
    case "RA_SR/CAMBIAR_VALOR_REAJUSTE_PQ": {
      return Object.assign({}, state, {
        valorReajustePaquetes: action.valorReajustePaquetes,
      });
    }
    case "RA_SR/CAMBIAR_ITEMS_ELIMINADOS": {
      return Object.assign({}, state, {
        itemsSolicitudReajusteEliminados: action.eliminados,
      });
    }
    case "RA_SR/CAMBIAR_VALOR_REAJUSTE_MAX": {
      return Object.assign({}, state, {
        valorReajusteMax: action.valorReajusteMax,
      });
    }

    case "RA_SR/CAMBIAR_VALOR_REAJUSTE_MAX_PQ": {
      return Object.assign({}, state, {
        valorReajusteMaxPQ: action.valorReajusteMax,
      });
    }

    case "RA_SR/CAMBIAR_VALOR_REAJUSTE_ERROR": {
      return Object.assign({}, state, {
        valorReajusteError: action.valorReajusteError,
      });
    }
    case "RA_SR/CAMBIAR_VALOR_REAJUSTE_ERROR_PQ": {
      return Object.assign({}, state, {
        valorReajustePaquetesError: action.valorReajustePaquetesError,
      });
    }

    case "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION": {
      if (action.isChecked) {
        return Object.assign({}, state, {
          checkCentrosAtencion: [...new Set([...state.checkCentrosAtencion, ...[action.id]])],
        });
      }
      return Object.assign({}, state, {
        checkCentrosAtencion: state.checkCentrosAtencion.filter((c) => c !== action.id),
      });
    }

    case "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_PQ": {
      if (action.isChecked) {
        return Object.assign({}, state, {
          checkCentrosAtencionPQ: [...new Set([...state.checkCentrosAtencionPQ, ...[action.id]])],
        });
      }
      return Object.assign({}, state, {
        checkCentrosAtencionPQ: state.checkCentrosAtencionPQ.filter((c) => c !== action.id),
      });
    }

    case "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_ERROR": {
      return Object.assign({}, state, {
        checkCentrosAtencionError: action.checkCentrosAtencionError,
      });
    }

    case "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_ERROR_PQ": {
      return Object.assign({}, state, {
        checkCentrosAtencionErrorPQ: action.checkCentrosAtencionErrorPQ,
      });
    }

    case "RA_SR/CAMBIAR_CHECK_VIGENCIAS_ERROR_PQ": {
      return Object.assign({}, state, {
        checkVigenciasErrorPQ: action.checkVigenciasErrorPQ,
      });
    }

    case "RA_SR/CAMBIAR_CHECK_TIPO_PRESTACION": {
      if (action.isChecked) {
        return Object.assign({}, state, {
          checkTiposPrestacion: [...new Set([...state.checkTiposPrestacion, ...[action.id]])],
        });
      }
      return Object.assign({}, state, {
        checkTiposPrestacion: state.checkTiposPrestacion.filter((c) => c !== action.id),
      });
    }

    case "RA_SR/CAMBIAR_CHECK_TIPO_PRESTACION_ERROR": {
      return Object.assign({}, state, {
        checkTiposPrestacionError: action.checkTiposPrestacionError,
      });
    }

    case "RA_SR/CAMBIAR_CHECK_ARANCEL": {
      if (action.isChecked) {
        return Object.assign({}, state, {
          checkAranceles: [...new Set([...state.checkAranceles, ...[action.id]])],
        });
      }
      return Object.assign({}, state, {
        checkAranceles: state.checkAranceles.filter((c) => c !== action.id),
      });
    }

    case "RA_SR/CAMBIAR_CHECK_VIGENCIA_PQ": {
      if (action.isChecked) {
        return Object.assign({}, state, {
          checkVigenciasPaquetes: [...new Set([...state.checkVigenciasPaquetes, ...[action.id]])],
        });
      }
      return Object.assign({}, state, {
        checkVigenciasPaquetes: state.checkVigenciasPaquetes.filter((c) => c !== action.id),
      });
    }

    case "RA_SR/CAMBIAR_CHECK_ARANCEL_ERROR": {
      return Object.assign({}, state, {
        checkArancelesError: action.checkArancelesError,
      });
    }


    case "RA_SR/CAMBIAR_CHECK_VIGENCIAS_ERROR": {
      return Object.assign({}, state, {
        checkVigenciasErrorPQ: action.checkVigenciasErrorPQ,
      });
    }

    case "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_TODOS": {
      return Object.assign({}, state, {
        checkCentrosAtencion: action.isChecked ? action.data : [],
      });
    }

    case "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_TODOS_PQ": {
      return Object.assign({}, state, {
        checkCentrosAtencionPQ: action.isChecked ? action.data : [],
      });
    }

    case "RA_SR/CAMBIAR_CHECK_VIGENCIA_PAQUETES_TODOS_PQ": {
      return Object.assign({}, state, {
        checkVigenciasPaquetes: action.isChecked ? action.data : [],
      });
    }

    case "RA_SR/CAMBIAR_CHECK_TIPO_PRESTACION_TODOS": {
      return Object.assign({}, state, {
        checkTiposPrestacion: action.isChecked ? action.data : [],
      });
    }

    case "RA_SR/CAMBIAR_CHECK_ARANCEL_TODOS": {
      return Object.assign({}, state, {
        checkAranceles: action.isChecked ? action.data : [],
      });
    }

    case "RA_SR/MODAL_CONFIRMAR_SOLICITUD": {
      return Object.assign({}, state, {
        modalConfirmarSolicitud: action.modalConfirmarSolicitud,
      });
    }

    case "RA_SR/CARGAR_CABECERA_SOLICITUD": {
      return Object.assign({}, state, {
        cabeceraSolicitud: {
          IdSolicitud: action.esReplicacion ? state.cabeceraSolicitud.IdSolicitud : action.cabeceraSolicitud.IdSolicitud,
          IdSolicitudReplicada: action.esReplicacion ? action.cabeceraSolicitud.IdSolicitud : null,
          IdSolicitudPQ: state.cabeceraSolicitud.IdSolicitudPQ,
          IdSolicitudPQReplicada: state.cabeceraSolicitud.IdSolicitudPQReplicada,
        },
      });
    }

    case "RA_SR/CARGAR_CABECERA_SOLICITUD_PQ": {
      return Object.assign({}, state, {
        cabeceraSolicitud: {
          IdSolicitudPQ: action.esReplicacion ? state.cabeceraSolicitud.IdSolicitudPQ : action.cabeceraSolicitud.IdSolicitud,
          IdSolicitudPQReplicada: action.esReplicacion ? action.cabeceraSolicitud.IdSolicitud : null,
          IdSolicitud: state.cabeceraSolicitud.IdSolicitud,
          IdSolicitudReplicada: state.cabeceraSolicitud.IdSolicitudReplicada,
        },
      });
    }

    case "RA_SR/SET_VALIDACION_USUARIO": {
      return Object.assign({}, state, {
        prestadorPuedeReplicar: action.prestadorPuedeReplicar,
        usuarioPuedeReplicar: action.usuarioPuedeReplicar,
      });
    }

    case "RA_SR/SET_DETALLE_VALIDACION_CENTROS_ATENCION": {
      if (state.detalleValidacionCentrosAtencion
        .filter((c) => c.secuencia === action.secuencia).length === 0) {
        return Object.assign({}, state, {
          detalleValidacionCentrosAtencion: state.detalleValidacionCentrosAtencion
            .concat([{
              secuencia: action.secuencia,
              valido: action.valido,
              secuenciaHomologo: action.secuenciaHomologo,
            }]),
        });
      }
      return Object.assign({}, state, {
        detalleValidacionCentrosAtencion: state.detalleValidacionCentrosAtencion
          .map((p) => Object.assign({}, p, {
            valido: action.secuencia === p.secuencia ? action.valido : p.valido,
            secuenciaHomologo: action.secuencia === p.secuencia ? action.secuenciaHomologo : p.secuenciaHomologo,
          })),
      });
    }

    case "RA_SR/SET_VALIDACION_EN_CURSO": {
      return Object.assign({}, state, {
        loadingValidacionSolicitudEnCurso: action.value,
      });
    }

    case "RA_SR/SET_VALIDACION_CENTROS_ATENCION": {
      return Object.assign({}, state, {
        loadingValidacionCentrosAtencion: action.value,
      });
    }

    case "RA_SR/CAMBIAR_VIGENCIA_REAJUSTE": {
      return Object.assign({}, state, {
        vigenciaReajuste: action.vigenciaReajuste,
      });
    }

    case "RA_SR/CAMBIAR_VIGENCIA_REAJUSTE_PQ": {
      return Object.assign({}, state, {
        vigenciaReajustePQ: action.vigenciaReajustePQ,
      });
    }

    case "RA_SR/VIGENCIA_REAJUSTE_ERROR": {
      return Object.assign({}, state, {
        vigenciaReajusteError: action.vigenciaReajusteError,
      });
    }
    case "RA_SR/VIGENCIA_REAJUSTE_ERROR_PQ": {
      return Object.assign({}, state, {
        vigenciaReajustePQError: action.vigenciaReajustePQError,
      });
    }

    case "RA_SR/CARGAR_VIGENCIAS_PAQUETES": {
      return Object.assign({}, state, {
        vigenciasPaquetes: action.vigencias,
      });
    }

    case "RA_SR/INICIO_REAJUSTE_ERROR": {
      return Object.assign({}, state, {
        inicioVigenciaReajusteError: action.inicioReajusteError,
      });
    }

    case "RA_SR/INICIO_REAJUSTE_PQ_ERROR": {
      return Object.assign({}, state, {
        inicioVigenciaReajustePQError: action.inicioReajustePQError,
      });
    }

    case "RA_SR/CAMBIAR_REPLICA_PQ": {
      return Object.assign({}, state, {
        replicaPaquetes: action.replicaPaquetes,
      });
    }

    case "RA_SR/REPLICA_PQ_ERROR": {
      return Object.assign({}, state, {
        replicaPaquetesError: action.error,
      });
    }


    case "RA_SR/CAMBIAR_REPLICA_ARANCEL": {
      return Object.assign({}, state, {
        replicaArancel: action.replicaArancel,
      });
    }

    case "RA_SR/REPLICA_ARANCEL_ERROR": {
      return Object.assign({}, state, {
        replicaArancelError: action.error,
      });
    }

    case "RA_SR/CARGAR_SOLICITUDES_EN_CURSO": {
      let solicitudesAux = state.solicitudesPendientes;
      if (action.solicitudes === null) {
        return Object.assign({}, state, {
          solicitudesPendientes: [],
        });
      }
      else {
        for (let i = 0; i < action.solicitudes.length; i++) {
          if ((solicitudesAux.some(item => item === action.solicitudes[i])) === false) {
            solicitudesAux.push(action.solicitudes[i])
          }
        }
        return Object.assign({}, state, {
          solicitudesPendientes: solicitudesAux,
        });
      }
    }

    case "RA_SR/CARGAR_SOLICITUDES_EN_CURSO_REP_A": {
      let solicitudesAux = state.solicitudesPendientesRepA;
      if (action.solicitudes === null) {
        return Object.assign({}, state, {
          solicitudesPendientesRepA: [],
        });
      } else {
        for (let i = 0; i < action.solicitudes.length; i++) {
          if ((solicitudesAux.some(item => item === action.solicitudes[i])) === false) {
            solicitudesAux.push(action.solicitudes[i])
          }
        }
        return Object.assign({}, state, {
          solicitudesPendientesRepA: solicitudesAux,
        });
      }
    }

    case "RA_SR/CARGAR_VIGENCIAS_NO_EXITENTES_REPLICA_PQ": {
      let vigenciasAux = state.vigenciasNoEnReplica;
      if (action.vigencias === null) {
        return Object.assign({}, state, {
          vigenciasNoEnReplica: [],
        });
      }
      else {
        for (let i = 0; i < action.vigencias.length; i++) {
          if ((vigenciasAux.some(item => item === action.vigencias[i])) === false) {
            vigenciasAux.push(action.vigencias[i])
          }
        }
        return Object.assign({}, state, {
          vigenciasNoEnReplica: vigenciasAux,
        });
      }
    }

    case "RA_SR/LOADING_VALIDACION": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    default:
      return state;
  }
};

export default solicitudReajusteReducer;



// WEBPACK FOOTER //
// ./src/components/ReajustarArancel/SolicitudReajuste/reducer.js